(function () {
	function activateTab(panel, tabId) {
		if (!panel || !tabId) {
			return;
		}

		panel.querySelectorAll('[data-target="product-tab-button"]').forEach((btn) => {
			const isActive = btn.dataset.tab === tabId;

			btn.classList.toggle('tab-panel__btn_active', isActive);
			btn.setAttribute('aria-selected', String(isActive));
		});

		panel.querySelectorAll('[data-target="product-tab"]').forEach((tab) => {
			const isActive = tab.dataset.tab === tabId;

			tab.classList.toggle('tab-panel__tab_active', isActive);
			tab.hidden = !isActive;
		});
	}

	function initProductTabPanels() {
		document.querySelectorAll('[data-target="product-tab-panel"]').forEach((panel) => {
			panel.addEventListener('click', (event) => {
				const btn = event.target.closest('[data-target="product-tab-button"]');

				if (!btn || !panel.contains(btn)) {
					return;
				}

				event.preventDefault();
				activateTab(panel, btn.dataset.tab);
			});
		});
	}

	document.addEventListener('DOMContentLoaded', () => {
		initProductTabPanels();
	});
})();